// The Feedback list on the Settings page, part of the removable feedback
// widget: see "Removing the feedback widget" in DECISIONS.md.
//
// Every note the floating button collected, newest first, with its exact
// comment, where it was written, who wrote it and any screenshots.

import { useCallback, useEffect, useState } from 'react'
import { useConfirm } from '../confirm.jsx'
import { formatInstant, SEPARATOR } from '../vocab.js'
import { Button, EmptyState, Notice, Panel } from '../components/ui/index.js'
import { listFeedback, removeFeedback } from './feedbackApi.js'
import './feedback.css'

export default function FeedbackSection() {
  const confirm = useConfirm()
  const [entries, setEntries] = useState(null)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    try {
      const data = await listFeedback()
      setEntries(data.entries)
      setError(null)
    } catch (caught) {
      setError(caught.message)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  async function drop(entry) {
    if (!(await confirm('Remove this feedback note?'))) return
    try {
      await removeFeedback(entry.id)
      load()
    } catch (caught) {
      setError(caught.message)
    }
  }

  return (
    <Panel
      title="Feedback"
      support="What admins flagged from inside the app with the floating button, newest first."
    >
      {error ? <Notice tone="bad">{error}</Notice> : null}

      {entries === null ? (
        <div className="center-note">Loading</div>
      ) : entries.length === 0 ? (
        <EmptyState title="Nothing yet">
          Notes sent from the feedback button appear here.
        </EmptyState>
      ) : (
        <div className="rows">
          {entries.map((entry) => (
            <div key={entry.id} className="row">
              <div className="row-main">
                <div className="row-primary wraps">{entry.comment}</div>
                <div className="row-meta">
                  {[entry.area, entry.path, entry.authorName, formatInstant(entry.createdAt)]
                    .filter(Boolean)
                    .join(SEPARATOR)}
                </div>
                {entry.screenshots.length ? (
                  <div className="feedback-shots">
                    {entry.screenshots.map((shot) => (
                      <a key={shot.id} href={shot.url} target="_blank" rel="noreferrer">
                        <img src={shot.url} alt={shot.fileName} />
                      </a>
                    ))}
                  </div>
                ) : null}
              </div>
              <div className="row-trail">
                <Button variant="ghost" onClick={() => drop(entry)}>
                  Remove
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  )
}
